import { useState } from 'react';
import { Link } from 'react-router-dom';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { name: 'Home', href: '/' },
    { name: 'Our Team', href: '/our-team' },
    { name: 'Onyx Health Advisory', href: '/health-advisory' },
    { name: 'Onyx Labs', href: '/onyx-labs' },
    { name: 'State & Federal Contracts', href: '/government-contracts' },
    { name: 'Insights', href: '/insights' },
  ];

  return (
    <nav className="fixed w-full bg-white shadow-md z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 gap-4 md:gap-8">
          <div className="flex-shrink-0">
            <a href="/" className="">
                <img src="/site-logo.png" alt="Company Logo" className="h-10 w-auto" />
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-3 lg:space-x-6">
            {navItems.map((item) => {
              const isInternalLink = item.href.startsWith('/') && !item.href.startsWith('/#');
              const Component = isInternalLink ? Link : 'a';
              const linkProps = isInternalLink ? { to: item.href } : { href: item.href };

              return (
                <Component
                  key={item.name}
                  {...linkProps}
                  className={item.style ? `${item.style} self-center` : "text-onyx-700 hover:text-accent transition-colors duration-200"}
                >
                  {item.name}
                </Component>
              );
            })}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-onyx-700 hover:text-accent focus:outline-none"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {navItems.map((item) => {
              const isInternalLink = item.href.startsWith('/') && !item.href.startsWith('/#');
              const Component = isInternalLink ? Link : 'a';
              const linkProps = isInternalLink ? { to: item.href } : { href: item.href };

              return (
                <Component
                  key={item.name}
                  {...linkProps}
                  className="block px-3 py-2 text-onyx-700 hover:text-accent hover:bg-gray-50 rounded-md"
                  onClick={() => setIsOpen(false)}
                >
                  {item.name}
                </Component>
              );
            })}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
